import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import { Analytics } from '@vercel/analytics/react';

import App from './App';
import Project from './Project';
import Navigator from './Navigator';

import './index.scss';
import './styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));

function Main() {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    const timer = setTimeout(() => setIsReady(true), 1100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <HelmetProvider>
      <div className={`preloader ${isReady ? 'is-hidden' : ''}`}>
        <div className='preloader-mark'>Isuru<span className='dot'>.</span></div>
        <div className='preloader-bar'><span /></div>
      </div>

      <Navigator />

      <Router>
        <Switch>
          <Route path='/' exact component={App} />
          <Route path='/projects/:id' exact component={Project} />
          <Redirect to="/" />
        </Switch>
      </Router>

      <Analytics />
    </HelmetProvider>
  );
}

root.render(<Main />);
